<template>
  <v-container class="ma-0 pa-0 commentBlock">
    <v-layout row class="commentAdditional px-1">
      <!-- <v-btn flat color="primary" @click="showForm = !showForm" class='ml-0'> -->
      <div class="commentCount">
        <v-icon>$vuetify.icons.amaze-comment</v-icon>
        <span>{{ commentCount }}</span>
      </div>
      <!-- </v-btn> -->
      <slot></slot>
    </v-layout>
    <hr class="my-3 blow2" />
    <v-container class="pa-0">
      <v-layout
        row
        wrap
        class="py-2 px-2 comment my-1"
        v-for="(comment, index) in comments"
        :key="comment.id"
        v-if="index == 0 || showForm"
      >
        <v-flex xs12 class="py-1">
          <AmazeAvatar
            :user="comment.user"
            :key="comment.user.id"
            size="25px"
            hideTip="true"
            class="mr-2"
          ></AmazeAvatar>
          <router-link :to="{ path: '/profile/' + comment.user.id }"
            ><span class="username groupUsername">{{
              comment.user.display_name
            }}</span></router-link
          >
          <span class="groupTimestamp timestamp time commentTime"
            >· {{ comment.created_at | localTime }} ago</span
          >
          <section class="created">
            <v-menu v-if="canDelete(comment)" class="cardMenu" bottom left>
              <v-btn slot="activator" icon>
                <v-icon color="primary">more_vert</v-icon>
              </v-btn>
              <v-list>
                <div v-if="canEdit(comment) && editing.id !== comment.id">
                  <v-list-tile @click="editComment(comment.id, index)">
                    <v-list-tile-title>Edit Comment</v-list-tile-title>
                  </v-list-tile>
                </div>
                <div v-if="canDelete(comment)">
                  <v-list-tile @click="deleteComment(comment.id, index)">
                    <v-list-tile-title>Delete Comment</v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list>
            </v-menu>
          </section>
        </v-flex>
        <v-flex
          color="secondary"
          v-if="editing.id === comment.id"
          class="py-0 pb-2 commentContent"
          xs12
        >
          <v-textarea
            v-bind:name="'edit-comment-' + comment.id"
            outline
            v-model="comment.comment"
            persistent-hint
            hint="Edit your comment and press save to update."
          ></v-textarea>
          <div class="">
            <v-btn
              color="primary"
              @click="saveComment"
              class="saveComment"
              >Save Edits</v-btn
            >
            <v-btn flat outline @click="cancelEdit(comment.id, index)"
              >Cancel</v-btn
            >
          </div>
        </v-flex>
        <v-flex v-else class="py-0 commentContent" xs12>
          {{ comment.comment }}
        </v-flex>
      </v-layout>

      <v-layout row wrap class="px-2" v-if="comments.length > 1">
        <a
          flat
          color="primary"
          @click="showForm = !showForm"
          class="ml-0 pt-2 commentsControl"
          ><span
            >View <span v-if="showForm"> fewer </span
            ><span v-else> more </span> comments</span
          ></a
        >
      </v-layout>
    </v-container>

    <v-layout row wrap class="pt-3 px-2">
      <v-textarea
        name="comment"
        outline
        v-model="newComment"
        placeholder="Leave a Comment"
        class="commentTextarea pr-1"
        auto-grow
        single-line
        rows="1"
        row-height="15"
        :rules="rules"
        ref="commentForm"
      ></v-textarea>
      <v-btn color="primary" @click="addComment" class="postComment"
        >Post</v-btn
      >
    </v-layout>
  </v-container>
</template>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';
.comment {
  .created {
    float: right;
    font-style: italic;
  }
  .commentContent {
    font-size: 14px;
    word-break: break-word;
  }
}
.postComment {
  align-self: flex-end;
  margin-bottom: 32px;
}
</style>

<style lang="scss">
@import 'src/styles/variables.scss';
.commentBlock .v-textarea textarea {
  margin-top: 0 !important;
}
.commentBlock .v-textarea .v-input__slot {
  min-height: 37px;
}
.commentBlock {
  color: $font-color;
  .commentAdditional {
    margin-top: -15px;
    .commentCount {
      margin-top: 2px;
      span {
        margin-top: -2px;
        font-size: 14px;
      }
    }
  }
}
a.commentsControl {
  color: $icon-blue;
  font-weight: bold;
  &:hover {
    color: $link-hover;
  }
}
.commentCount {
  min-width: 3em !important;
  justify-content: left !important;
}
</style>

<script>
import AmazeAvatar from '@/components/Widgets/AmazeAvatar'

export default {
  components: {
    AmazeAvatar
  },
  props: ['cardId', 'groupId', 'inputComments', 'group'],
  data () {
    return {
      editing: false,
      restoreComment: "",
      showForm: false,
      newComment: null,
      comments: this.inputComments,
      rules: [
        v => !!v || 'Please enter a comment.',
        v =>
          (v && (v || '').length < 65535) ||
          'Please limit your comment to 65535 characters or less.'
      ]
    }
  },
  computed: {
    commentCount () {
      return this.comments.length < 1
        ? 0
        : this.comments.length < 1000
          ? this.comments.length
          : '999+'
    },
    newCommentEmpty () {
      console.log('new comment empty', this.newComment.length)
      return this.newComment.length < 1 || this.newComment === ''
    }
  },
  methods: {
    canEdit (comment) {
      // Permissions for delete and edit are the same.
      return this.canDelete(comment)
    },
    canDelete (comment) {
      // This user can delete a comment if they are the creator of the comment,
      // if they are an uber admin, or if they are a group admin.
      return (
        this.$auth.user().id === comment.user.id ||
        this.$auth.check('uber_admin') ||
        (this.group && this.group.hasOwnProperty('my_role')
          ? this.group.my_role === 'admin'
          : false)
      )
    },
    editComment (commentId, index) {
      this.editing = this.comments[index];
      this.restoreComment = this.comments[index].comment;
    },
    cancelEdit(commentId, index) {
      this.editing = false;
      this.comments[index].comment = this.restoreComment;
    },
    saveComment() {
      let comment = this.comments.find(comment => comment.id === this.editing.id);
      this.$http.put('cardComments/' + this.editing.id, { user_id: this.editing.user_id, card_id: this.editing.card_id, id: this.editing.id, comment: this.editing.comment }).then(
        response => {
          this.editing = false;
        },
        response => {
          console.log('Error updating comment.');
        }
      );
    },
    addComment () {
      if (this.newComment !== '' && this.$refs.commentForm.validate()) {
        let data = {
          user_id: this.$auth.user().id,
          card_id: this.cardId,
          group_id: this.groupId,
          comment: this.newComment
        }
        this.$http.post('cardComments', data).then(
          response => {
            this.comments.push(response.body.data)
            this.newComment = ''
            this.$refs.commentForm.reset()
          },
          response => {
            console.log('Error sending like!')
          }
        )
      } else {
        this.$store.commit('updateMessage', {
          message:
            this.newComment !== ''
              ? 'Unable to add your comment.'
              : 'Please enter a comment.',
          snackbar: true
        })
      }
    },
    cancelComment () {
      this.showForm = false
      this.newComment = ''
    },
    deleteComment (commentId, commentIndex) {
      // optimistic delete
      this.comments.splice(commentIndex, 1)
      this.$http.delete('cardComments/' + commentId).then(
        response => {
          // actually deleted
        },
        response => {
          console.log('Error deleting file.')
        }
      )
    }
  }
}
</script>
